import colors from 'styles/colors';

const MainTheme = {
  ...colors,
};

export default MainTheme;
